module.exports = __webpack_public_path__ + "img/magic.641f6630.svg";